import { AvatarTitle, StackScreen } from '@life-line-lab/components-react';
import ProfileForm from 'Components/profile/profile-details';
import useRefreshOneProfileQuery from 'Hooks/refresh-one-profile.hook';
import useSession from 'Hooks/session.hook';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { updateProfile } from 'Services/profile.services';

const UpdateProfilePage = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { profile } = useSession();
  const profileID = profile._id;

  const [profileData] = useRefreshOneProfileQuery({
    profileID: profileID as string,
  });

  const handleCloseStackScreen = () => {
    history.goBack();
  };

  const handleSubmit = async (data: any) => {
    const serviceToCall = updateProfile;
    const result = await serviceToCall(data);
    return result;
  };

  return (
    <div className="profile-update-page">
      <Helmet>
        <title>{t('title.updateProfile')}</title>
      </Helmet>

      <StackScreen
        title={<AvatarTitle text={t('title.updateProfile')} />}
        isOpen={true}
        renderHeader={<div></div>}
        onClose={handleCloseStackScreen}
      >
        {profileData && (
          <ProfileForm
            handleCloseStackScreen={(handleCloseStackScreen)}
            data={profileData}
            handleSubmit={handleSubmit}
          />
        )}
      </StackScreen>
    </div>
  );
};

export default UpdateProfilePage;
